'use client';

import React from 'react';
import GeneralChart from '../GeneralChart';
import GeneralMenu from '../../navigation/GeneralMenu';
import { isEmpty, convertToStrList } from '@/utils/seo-content';

interface Props {
  show: boolean;
  transformationData: Record<string, any>;
  companyRiskData: Record<string, any>;
  companyOpportunityData: Record<string, any>;
}

const OPPORTUNITIES_AND_CHALLENGES_ITEMS = [
  {
    name: 'AI时代下，此公司是如何应对的？— 以下是我们为你整理的信息',
    id: 'company-opportunities-and-challenges_company_response_method',
  },
  {
    name: '这家公司的风险与机遇 — 求职者要如何应对？',
    id: 'company-opportunities-and-challenges_job_seeker_response_method',
  },
  // { name: '其他会影响求职者决策的关键问题', id: 'company-opportunities-and-challenges_other_questions' },
];

const RiskAndOpportunitySwitcher = ({
  data,
}: {
  data: Record<string, any>;
}) => {
  const stages = ['风险与应对', '机会与成长'];
  const [activeStage, setActiveStage] = React.useState(stages[0]);
  return (
    <>
      <div className="flex gap-10 mb-4">
        {stages.map((stage, index) => (
          <span
            key={index}
            onClick={() => setActiveStage(stage)}
            className={`transition-colors cursor-pointer font-semibold ${
              activeStage === stage
                ? 'border-b border-primary border-solid'
                : 'text-web-grey-600 hover:text-primary'
            }`}
          >
            {stage}
          </span>
        ))}
      </div>
      {stages.map((stage, index) => (
        <div
          key={index}
          className={`flex flex-col gap-4 ${activeStage === stage ? 'block' : 'max-h-0 overflow-hidden'}`}
        >
          {data[stage]?.map((item: Record<string, any>, idx: number) => (
            <div key={idx}>
              <h4 className="font-semibold mb-2">
                {['风险', '机会'][index]}
                {'一二三四五'[idx]}：{item['标题']}
              </h4>
              <p className="mb-2">对你的影响：</p>
              <ul className="list-inside !ml-2 mb-2">
                {(item['对你的影响'] || []).map(
                  (itm: string, index: number) => (
                    <li key={index}>{itm}</li>
                  ),
                )}
              </ul>
              <p className="mb-2">应对策略：</p>
              <ul className="list-inside !ml-2">
                {(item['应对策略'] || []).map((itm: string, index: number) => (
                  <li key={index}>{itm}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

const OpportunitiesAndChallengesTabPanel = (props: Props) => {
  const {
    show,
    transformationData = {},
    companyRiskData = {},
    companyOpportunityData = {},
  } = props;
  const keyFocus = convertToStrList(transformationData['发力重点'], [
    '要点',
    '说明',
  ]);
  const menuList = [OPPORTUNITIES_AND_CHALLENGES_ITEMS[1]];
  if (!isEmpty(transformationData['tip'])) {
    menuList.unshift(OPPORTUNITIES_AND_CHALLENGES_ITEMS[0]);
  }
  return (
    <div hidden={!show} className="relative">
      <GeneralMenu menuList={menuList} />
      <h2 className="text-xl font-semibold">
        作为求职者，如何分析公司的未来发展
      </h2>
      {!isEmpty(transformationData['tip']) && (
        <GeneralChart
          id={OPPORTUNITIES_AND_CHALLENGES_ITEMS[0].id}
          title={OPPORTUNITIES_AND_CHALLENGES_ITEMS[0].name}
          tip={transformationData['tip']}
          tipBgColor="bg-web-purple-100"
        >
          <p className="mb-4">{transformationData['导语']}</p>
          {keyFocus.length > 0 && (
            <>
              <h4 className="font-semibold mb-2">发力重点</h4>
              <ul className="list-inside !ml-2">
                {keyFocus.map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </>
          )}
          {!isEmpty(transformationData['未来3-5年核心驱动力']['总结']) && (
            <>
              <h4 className="font-semibold mt-4 mb-2">
                未来 3-5 年的核心驱动力
              </h4>
              <ul className="list-inside !ml-2">
                {(
                  transformationData['未来3-5年核心驱动力']?.['要点'] || []
                ).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </>
          )}

          <h4 className="font-semibold mt-4 mb-2">长期路线</h4>
          <ul className="list-inside !ml-2">
            <li>短期：{transformationData['长期路线']?.['短期']}</li>
            <li>中期：{transformationData['长期路线']?.['中期']}</li>
            <li>长期：{transformationData['长期路线']?.['长期']}</li>
          </ul>
        </GeneralChart>
      )}
      <GeneralChart
        id={OPPORTUNITIES_AND_CHALLENGES_ITEMS[1].id}
        title={OPPORTUNITIES_AND_CHALLENGES_ITEMS[1].name}
        tip={companyOpportunityData['总结提示']}
        tipBgColor="bg-web-purple-100"
      >
        <RiskAndOpportunitySwitcher
          data={{
            风险与应对: companyRiskData['风险与应对'],
            机会与成长: companyOpportunityData['机会与成长'],
          }}
        />
      </GeneralChart>
    </div>
  );
};

export default OpportunitiesAndChallengesTabPanel;
